import _ from 'lodash';

export const findById = (state, storyId) => {
    return state.stories[storyId];
};

export const filterByProjectId = (state, projectId) => {
    return _.filter(state.stories, story => story.projects.includes(projectId))
};
